/**
 * Environment configuration for the client
 * This loads variables from the .env file through Vite's import.meta.env
 */

// Type declaration for Vite's import.meta.env
declare global {
  interface ImportMeta {
    env: {
      VITE_WS_CLIENT_URL?: string;
      VITE_RECONNECT_ATTEMPTS?: string;
      [key: string]: string | undefined;
    };
  }
}

// Server connection
export const WS_CLIENT_URL = import.meta.env.VITE_WS_CLIENT_URL;

// Game configuration
export const MAX_RECONNECT_ATTEMPTS = parseInt(import.meta.env.VITE_RECONNECT_ATTEMPTS || '5', 10);

// Export all environment variables in a single object
export const ENV = {
    WS_CLIENT_URL,
    MAX_RECONNECT_ATTEMPTS
}; 